const React = require('react');
const ReactDOM = require('react-dom');
const { createRoot } = require('react-dom/client');
const axios = require('axios');

import Styles from "./css";
import Layout from "./components/stateless/Layout.jsx";
import SchoolLink from "./components/stateless/SchoolLink.jsx";
import AppInfo from "./components/stateless/AppInfo.jsx";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

class ChooseSchool extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            mode: 'info', // 'info', 'school', 'master'
            schoolData: null, // For single school mode
            schoolsList: [] // For master mode
        };
    }

    componentDidMount() {
        const path = window.location.pathname;
        if (path === '/info') {
            this.setState({ mode: 'info', isLoading: false });
            return;
        }

        const lastSchool = getCookie('last_school');

        if (!lastSchool) {
            this.setState({ mode: 'info', isLoading: false });
        } else if (lastSchool === '_master') {
            this.setState({ mode: 'master' });
            axios.get('/api/all_schools')
                .then(res => {
                    this.setState({ schoolsList: res.data, isLoading: false });
                })
                .catch(err => {
                    console.error("Failed to fetch schools", err);
                    this.setState({ mode: 'info', isLoading: false });
                });
        } else {
            // Specific school
            this.setState({ mode: 'school' });
            axios.get(`/api/${lastSchool}`)
                .then(res => {
                    this.setState({ schoolData: res.data, isLoading: false });
                })
                .catch(err => {
                    console.error("Failed to fetch school data", err);
                    // Fallback to info if school not found
                    this.setState({ mode: 'info', isLoading: false });
                });
        }
    }

    render() {
        const { isLoading, mode, schoolData, schoolsList } = this.state;

        let content;
        let title = "ברוכים הבאים";
        let subtitle = "אנא בחרו את בית ספרכם";

        if (isLoading) {
             return <Layout title={title} isLoading={true} />;
        }

        if (mode === 'info') {
            // For info page, we use a generic title or keep "Welcome" but show info
            // The prompt asked for "front page show some information".
            // I'll keep title empty or minimal.
            title = "אודות DCat";
            subtitle = "";
            content = <AppInfo />;
        } else if (mode === 'master') {
            title = "Super Admin Access";
            subtitle = "Select a school to manage";
            content = (
                <div>
                    <div style={{textAlign: 'center', marginBottom: '20px'}}>
                        <a href="/super-admin" style={{fontSize: '20px', fontWeight: 'bold'}}>Go to Super Admin Dashboard</a>
                    </div>
                    {schoolsList.map((school, i) => (
                        <SchoolLink
                            schoolName={school.name}
                            schoolHebName={school.heb_name}
                            key={school._id}
                            backColor={i % 2 === 0 ? undefined : Styles.colors.lightGray}
                        />
                    ))}
                </div>
            );
        } else if (mode === 'school' && schoolData) {
            title = schoolData.heb_name;
            subtitle = "בחרו פעולה";
            const btnStyle = {
                ...Styles.button,
                display: 'block',
                width: '100%',
                maxWidth: '300px',
                margin: '10px auto',
                textDecoration: 'none',
                fontSize: '18px'
            };

            content = (
                <div style={{textAlign: 'center'}}>
                    <a href={`/${schoolData.name}/submit`} style={btnStyle}>
                        הגשת תלונה
                    </a>
                    {schoolData.license_type === 'APPEALS' && (
                        <a href={`/${schoolData.name}/appeal`} style={btnStyle}>
                            הגשת ערעור
                        </a>
                    )}
                </div>
            );
        }

        return (
            <Layout title={title} subtitle={subtitle}>
                {content}
            </Layout>
        );
    }
}

const root = createRoot(document.getElementById('app'));
root.render(<ChooseSchool />);
